import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Learner } from '../../models/Learner';
import { ValidationService } from '../../services/validation.service';
import { LearnerService } from '../../services/learner.service';
import { UnfocusElementService } from '../../services/unfocus-element.service';
import { CryptoService } from '../../services/crypto.service';
import { StorageService } from 'src/app/services/storageService.service';

@Component({
  selector: 'app-add-learner-modal',
  templateUrl: './add-learner-modal.page.html',
  styleUrls: ['./add-learner-modal.page.scss'],
})
export class AddLearnerModalPage implements OnInit {

  public learner: Learner;
  public isEditing: boolean;
  constructor(
    public modalController: ModalController,
    public validationService: ValidationService,
    public learnerService: LearnerService,
    public unfocusService: UnfocusElementService,
    public cryptoService: CryptoService,
    public storageService: StorageService
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalController.dismiss();
  }

  saveLearner(event) {
    this.unfocusService.unfocus(event);
    if (this.validationService.isLearnerValid(this.learner)) {
      if (this.isEditing) {
        var learnersWithoutEditingLearner = this.learnerService.learners.filter(x => x.learnerId != this.learner.learnerId);
        if (learnersWithoutEditingLearner.filter(x => x.username == this.learner.username).length == 0) {
          if (learnersWithoutEditingLearner.filter(x => String(x.email).toLowerCase() == String(this.learner.email).toLowerCase()).length == 0) {
            this.learnerService.updateLearner(this.learner).then(x => {
              this.modalController.dismiss();
            });
          }
          else {
            this.validationService.createAlert("This learner email already exists. Please add a unique email for this learner.");
          }
        }
        else {
          this.validationService.createAlert("This learner username already exists. Please add a unique username for this learner.");
        }
      }
      else {
        if (this.learnerService.learners.filter(x => x.username == this.learner.username).length == 0) {
          if (this.learnerService.learners.filter(x => String(x.email).toLowerCase() == String(this.learner.email).toLowerCase()).length == 0) {
            this.learner.customerId = +this.cryptoService.decryptData(this.storageService.getItem('customerId'));
            this.learnerService.addLearner(this.learner).then(x => {
              this.modalController.dismiss();
            });
          }
          else {
            this.validationService.createAlert("This learner email already exists. Please add a unique email for this learner.");
          }
        }
        else {
          this.validationService.createAlert("This learner username already exists. Please add a unique username for this learner.");
        }
      }
    }
    else {
      this.validationService.alertForLearnerErrors(this.learner);
    }
  }
}
